import { render, staticRenderFns } from "./bookmakercomparison.vue?vue&type=template&id=a59502c4&scoped=true"
import script from "./bookmakercomparison.vue?vue&type=script&lang=js"
export * from "./bookmakercomparison.vue?vue&type=script&lang=js"
import style0 from "./bookmakercomparison.vue?vue&type=style&index=0&id=a59502c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59502c4",
  null
  
)

export default component.exports